import { FC } from "react";
import { IMeterDeliveryRequestFormSchema } from "./schema";
import moment from "moment";

const MeterInfoSummary: FC<{ data: IMeterDeliveryRequestFormSchema["contractInfo"], values: IMeterDeliveryRequestFormSchema, }> = ({ data, values }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div className=''>
      <span className="text-xs font-light">Contract Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Contract Number
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.contractNumber || "N/A"}
          </div>
        </div>
        <div className="col-span-2">
          <span className="block text-sm font-light text-gray-700">
            Contract Title
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.contractTitle || "N/A"}
          </div>
        </div>
        <div className="col-span-2">
          <span className="block text-sm font-light text-gray-700">
            Test At Meter Suppliers Facility?
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {Boolean(data.testAtOwnFacility) ? "Yes" : "No"}
          </div>
        </div>
      </div>
    </div>
    <div className='pt-6'>
      <span className="text-xs font-light">Timeline Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Proposed FAT Start Date
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {moment(data?.proposedStartDate).format("DD/MM/YYYY") || "N/A"}
          </div>
        </div>
        <div>
          <span className="block text-sm font-light text-gray-700">
            Exp. Production Completion Date
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {moment(data?.estimatedProductionCompletionDate).format("DD/MM/YYYY") || "N/A"}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default MeterInfoSummary;